module.exports = __webpack_public_path__ + "static/faq-bcadf0c8956e7dce112b85f1c10b97cb.jpg";